import { getAnalyticsDepositUiSource } from "./depositUiSource"
import { AnalyticsEvent, type DepositMethod } from "./events"
import { trackAnalyticsEvent } from "./track"

const PENDING_DEPOSIT_TTL_MS = 60 * 60 * 1000

let pendingTonDeposit: {
  deposit_method: DepositMethod
  amount_ton: number
  initiatedAtMs: number
} | null = null

/** Call after `deposit_initiated` (invoice / TonConnect tx sent). */
export function registerPendingTonDeposit(
  deposit_method: DepositMethod,
  amount_ton: number
): void {
  pendingTonDeposit = {
    deposit_method,
    amount_ton,
    initiatedAtMs: Date.now(),
  }
}

/**
 * Centrifugo `BalanceUpdated` (TON): credit after a recent `deposit_initiated`.
 * `new_balance` on the wire is final nanotons; we emit credited delta vs cached balance.
 */
export function trackTonDepositCompletedIfApplicable(
  previousBalanceNano: number | null,
  newBalanceNano: number
): void {
  if (!pendingTonDeposit) return
  if (Date.now() - pendingTonDeposit.initiatedAtMs > PENDING_DEPOSIT_TTL_MS) {
    pendingTonDeposit = null
    return
  }
  if (
    previousBalanceNano == null ||
    !Number.isFinite(newBalanceNano) ||
    newBalanceNano <= previousBalanceNano
  ) {
    return
  }

  const creditedTon = (newBalanceNano - previousBalanceNano) / 1e9
  trackAnalyticsEvent(AnalyticsEvent.DepositCompleted, {
    deposit_method: pendingTonDeposit.deposit_method,
    amount_ton: creditedTon,
    new_balance_ton: newBalanceNano / 1e9,
    deposit_ui_source: getAnalyticsDepositUiSource(),
  })
  pendingTonDeposit = null
}
